import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import { useHistory } from "react-router-dom";

import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'

import RegisterTable from '../../components/registerTable/index.js'
import RegisterFile from '../../components/registerFile/index.js'
import PreIngestionFilter from '../../components/preIngestionFilter';

const PreIngestion = () => {
    let history = useHistory();

    const [typeRegister, setTypeRegister]   = useState('')
    const [env, setEnv]                     = useState('')
    const [layer, setLayer]                 = useState('')


    const submitPreIngestion = (Event) => {
        Event.preventDefault();

        console.log("typeRegister:", typeRegister, "env:", env, "layer:", layer);

        if (typeRegister != '' & env != '' & layer != '') {
            history.push("/register?typeRegister=" + typeRegister );
        } else {
            alert('Deve-se preencher os valores obrigatórios')
        }
    }


    return (
        <div>
            <Header />

            <PreIngestionFilter setTypeRegister={setTypeRegister} setEnv={setEnv} setLayer={setLayer} submitPreIngestion={submitPreIngestion} />

            <Footer />
            
        </div>
    );
}

export default PreIngestion;
